import { render, staticRenderFns } from "./organizationStructure.vue?vue&type=template&id=af89b698&"
import script from "./organizationStructure.vue?vue&type=script&lang=js&"
export * from "./organizationStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports